(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/handle-pay-response.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/handle-pay-response.js');

'use strict';

const badDrawNumberErrorCodes = [8104,
8105,
8146,
104,
105,
146 
];
const _svs$numbergames = svs.numbergames,
  _svs$numbergames$draw = _svs$numbergames.draws,
  asyncDrawsApi = _svs$numbergames$draw.asyncDrawsApi,
  asyncJackpotApi = _svs$numbergames$draw.asyncJackpotApi,
  productMapping = _svs$numbergames.productMapping;
async function fetchAndUpdateDraws() {
  const drawsOptions = svs.gamePackage.data.packageConfig.drawsOptions;
  const updateDraws = svs.gamePackage.redux.gamePackageSlice.actions.updateDraws;
  const getPackageDraws = svs.gamePackage.mappers.getPackageDraws;
  await asyncDrawsApi.findDraw(drawsOptions);
  await asyncJackpotApi.jackpot(drawsOptions);
  svs.gamePackage.redux.store.dispatch(updateDraws(getPackageDraws()));
}
function isGamePackageClosed() {
  return svs.gamePackage.redux.store.getState().gamePackage.packageIsClosed;
}
function findClosedProducts(wagers) {
  const draws = svs.gamePackage.redux.store.getState().numbergames.draws;
  const closedProducts = [];
  wagers.forEach(wager => {
    const _wager$bets$ = wager.bets[0],
      productId = _wager$bets$.productId,
      drawNum = _wager$bets$.drawNum;
    const draw = draws.find(draw => productMapping.isSameProduct(draw.productItsId, productId));
    if (draw.drawNumber > drawNum) {
      closedProducts.push(productId);
    }
  });
  return closedProducts;
}
async function handlePayResponse(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    regWagerResults = _ref.regWagerResults,
    wagers = _ref.wagers,
    _ref$successfulWagers = _ref.successfulWagers,
    successfulWagers = _ref$successfulWagers === void 0 ? [] : _ref$successfulWagers,
    _ref$failedWagers = _ref.failedWagers,
    failedWagers = _ref$failedWagers === void 0 ? [] : _ref$failedWagers;
  const incompleteWagers = [];
  for (let i = 0, len = regWagerResults.length; i < len; i++) {
    const _regWagerResults$i = regWagerResults[i],
      status = _regWagerResults$i.status,
      regWagerResult = _regWagerResults$i.regWagerResult,
      tpError = _regWagerResults$i.tpError;
    const wager = wagers[wagers.length - (regWagerResults.length - i)];
    if (status === 'FAILURE') {
      const productId = wager.bets[0].productId;
      if (i === 0 && regWagerResults.length === wagers.length) {
        const errorCode = typeof tpError.errCode === 'string' ? parseInt(tpError.errCode.replace(/\s/g, ''), 10) : tpError.errCode;
        if (badDrawNumberErrorCodes.includes(errorCode)) {
          await fetchAndUpdateDraws();
        }
        if (isGamePackageClosed()) {
          svs.gamePackage.logger.info('GamePackage was closed before payment.');
          return cancel();
        }
        const closedProductItsIds = findClosedProducts(wagers);
        if (closedProductItsIds.length) {
          svs.gamePackage.logger.info("Draw for ".concat(closedProductItsIds.join(' and '), " was closed before payment."));
          return next({
            drawIsClosed: true,
            closedProductItsIds
          });
        }
      }
      failedWagers.push({
        tpError,
        wager
      });
      svs.gamePackage.logger.warn("Failed to pay ".concat(productId, ". Reason ").concat(tpError.errDesc, "."));
    }
    if (status === 'INCOMPLETE') {
      incompleteWagers.push(wager);
    }
    if (status === 'SUCCESS') {
      successfulWagers.push({
        wagerClientSerial: regWagerResult.wagerClientSerial,
        wagerAmounts: regWagerResult.wagerAmounts,
        wager
      });
    }
  }
  if (!successfulWagers.length && !incompleteWagers.length) {
    return svs.tur.apierrors.showErrorMessage({
      response: failedWagers[0].tpError.errCode,
      onConfirm: cancel
    });
  }
  if (incompleteWagers.length) {
    return next({
      incompleteWagers,
      successfulWagers,
      failedWagers
    });
  }
  next({
    successfulWagers,
    failedWagers
  });
}
svs.gamePackage.pay.handlePayResponse = handlePayResponse;

 })(window);